<template>
  <div>
    <div id="content" class="content animated slideInRight delay-1s">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ users_groups.id ? "Editar Grupo" : "Cadastrar Novo Grupo" }}
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form id="form">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span> Título:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="users_groups.title"
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="userDepartment">
                            <span class="required">*</span> Empresa:
                          </label>
                          <v-select
                            :options="companies"
                            label="company_name"
                            :reduce="(companies) => companies.id"
                            class="style-chooser"
                            v-model="users_groups.company_id"
                          >
                            <div slot="no-options">
                              Nenhum registro encontrado.
                            </div>
                          </v-select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-8">
                        <div class="form-group">
                          <label for="description"> Descrição: </label>
                          <textarea
                            v-model="users_groups.description"
                            name="description"
                            cols="100"
                            class="form-control"
                            rows="10"
                            placeholder=""
                            autocomplete="new-password"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                      <router-link to="/users_groups" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      users_groups: {
        title: "",
        description: "",
        company_id: "",
      },
      companies: [],
    };
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      fd.append("title", self.users_groups.title);
      fd.append("description", self.users_groups.description);
      fd.append("company_id", self.users_groups.company_id);

      if (self.users_groups.id) {
        fd.append("id", self.users_groups.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "users_groups";

      let fd = self.makeFormData();

      if (self.users_groups.id) {
        api += "/" + self.users_groups.id;
      }

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/users_groups");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUsersGroups: function (id) {
      const self = this;
      const api = self.$store.state.api + "users_groups/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.users_groups = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies/?paginated=false";
      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.getCompanies();

    if (id) {
      self.getUsersGroups(id);
    }
  },
  components: {
    vSelect,
  },
};
</script>
<style scoped>
.select {
  height: 10px;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
</style>


// WEBPACK FOOTER //
// src/components/UserGroups/Add.vue